import { useQuery } from "@apollo/client";

import { gql, MeGetProjectInfoQuery } from "~/__generated__";

export const ME_GET_PROJECT_INFO = gql(`
query MeGetProjectInfo($projectSlug: String!) {
    meGetProjectInfo(projectSlug: $projectSlug) {
        project {
            clientId
            id
            name
            slug
            contactName
            contactPhone
            contactEmail
            status
            isSpeciesManagementPlan
            showAllObservationsToClientUser
            startAt
            travelAllowancePerKmInCents
            travelAllowanceKms
            travelAllowanceTimeInSeconds
            client {
                id
                name
                slug
                address
                contactName
                contactPhone
                contactEmail
                type
                tenantId
            }
            plannerAreas {
                id
                featureId
                projectId
                location
                name
            }
            allowedActions {
                changeStatus {
                    allowed
                    reason
                }
            }
        }
        permissions
    }
}
`);

export type GqlMeGetProjectInfo = NonNullable<MeGetProjectInfoQuery["meGetProjectInfo"]>;
export type GqlProjectMetadata = NonNullable<MeGetProjectInfoQuery["meGetProjectInfo"]["project"]>;

export default function useMeGetProjectInfoQuery(projectSlug: string) {
    const { data, loading, error } = useQuery(ME_GET_PROJECT_INFO, {
        variables: { projectSlug },
    });
    return {
        loading,
        error,
        data: data?.meGetProjectInfo,
    };
}
